/* globals document, window */
import React, { Fragment } from "react";
import { parse } from "querystring";
import GlobalAlert from "../common/GlobalAlert";
import BlogPostGrid from "./BlogPostGrid";
import BlogListHeader from "./BlogListHeader";
import BlogNotFound from "./BlogNotFound";
import BlogGridWrapper from "./BlogGridWrapper";

import Pagination from "../common/Pagination";
import { GlobalProvider } from "../common/GlobalContext";

type Props = {
  alerts: Array<Object>,
  className: string,
  compliance: Object,
  favorites: Array<number>,
  listings: Array<Object>,
  pagination: Object,
  RECAPTCHA_CLIENT: string,
  siteUser: Object,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

const BlogList = ({
  alerts,
  compliance,
  favorites,
  location,
  pagination,
  posts,
  RECAPTCHA_CLIENT,
  RECAPTCHA_CLIENT_V2,
  siteUser,
  theme,
  title,
}: Props) => {
  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <GlobalAlert alerts={alerts} />
      {posts && posts.length > 0 ? (
        <Fragment>
          <BlogListHeader title={title} />
          <div style={{ background: "#fafafa" }}>
            <BlogGridWrapper posts={posts}>
              <BlogPostGrid
                pagination={pagination}
                posts={posts}
                location={location}
              />
            </BlogGridWrapper>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              pagination={pagination}
              path={(location && location.pathname) || "/blog"}
              query={
                location && location.search
                  ? parse(location.search.replace("?", ""))
                  : {}
              }
            />
          </div>
        </Fragment>
      ) : (
        <BlogNotFound />
      )}
    </GlobalProvider>
  );
};

export default BlogList;
